module.exports = __webpack_public_path__ + "img/1557614088930009091.a8dcc77a.png";